// extracted by mini-css-extract-plugin
export default {"checkboxes":"EditParticipationModal__checkboxes_____tpK","warningIcon":"EditParticipationModal__warningIcon___XTlEI"};